export default "__VITE_ASSET__Di1DJWPF__"